import React from 'react';
import DashboardIcon from '@mui/icons-material/Dashboard';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import PaidIcon from '@mui/icons-material/Paid';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import RequestPageIcon from '@mui/icons-material/RequestPage';
import HistoryToggleOffIcon from '@mui/icons-material/HistoryToggleOff';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import RuleIcon from '@mui/icons-material/Rule';
import BadgeIcon from '@mui/icons-material/Badge';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import StoreIcon from '@mui/icons-material/Store';
import BuildCircleIcon from '@mui/icons-material/BuildCircle';

import NivelAut from '../NivelAut/NivelAut';
import Tesorero from '../Tesorero/Tesorero';
import TesoreroSolicitudes from '../TesoreroSolicitudes/TesoreroSolicitudes';
import Solicitudes from '../Solicitudes/Solicitudes';
import Usuarios from '../Usuarios/Usuarios';
import SolicitudesProgramadas from '../SolicitudesProgramadas/SolicitudesProgramadas';
import SolicitudesAdmin from '../SolicitudesAdmin/SolicitudesAdmin';
import ResumenCentroCosto from '../ResumenCentroCosto/ResumenCentroCosto';
import ReporteAutorizadas from '../ReporteAutorizadas/ReporteAutorizadas';
import Bitacora from '../Bitacora/Bitacora';
import PagosAut from '../PagosAut/PagosAut';
import Perfiles from '../Perfiles/Perfiles';
import DashboardPage from '../DashboardPage/DashboardPage';
import CentroCosto from '../CentroCosto/CentroCosto';
import Departamento from '../Departamento/Departamento';
import Proveedores from '../Proveedores/Proveedores';
import SolicitudesCorregir from '../SolicitudesCorregir/SolicitudesCorregir';
import ControlExhibits from '../ControlExhibits/ControlExhibits';
import Funciones from '../Funciones/Funciones';
import ControlBD from '../ControlBD/ControlBD';
import StorageIcon from '@mui/icons-material/Storage';

export const Items = [
  // ── GENERAL ──────────────────────────────────────────────────────────────
  {
    id: 12,
    title: 'Dashboard',
    titleMenu: 'Dashboard',
    icon: <DashboardIcon />,
    path: '/DashboardPage',
    component: DashboardPage,
  },
  {
    id: 21,
    title: 'Panel de Gestión',
    titleMenu: 'Panel de Gestión',
    icon: <SpaceDashboardIcon />,
    path: '/ResumenCentroCosto',
    component: ResumenCentroCosto,
  },

  // ── OPERACIÓN Y PAGOS ────────────────────────────────────────────────────
  {
    id: 1,
    title: 'Órdenes de Compra',
    titleMenu: 'Órdenes de Compra',
    icon: <ShoppingCartIcon />,
    path: '/Solicitudes',
    component: Solicitudes,
  },
  {
    id: 2,
    title: 'Solicitudes por Autorizar',
    titleMenu: 'Por Autorizar',
    icon: <FactCheckIcon />,
    path: '/PagosAut',
    component: PagosAut,
  },
  {
    id: 17,
    title: 'Solicitudes Vencidas',
    titleMenu: 'Solicitudes Vencidas',
    icon: <EventBusyIcon />,
    path: '/SolicitudesCorregir',
    component: SolicitudesCorregir,
  },
  {
    id: 3,
    title: 'Historial de Solicitudes',
    titleMenu: 'Historial Solicitudes',
    icon: <HistoryEduIcon />,
    path: '/SolicitudesProgramadas',
    component: SolicitudesProgramadas,
  },
  {
    id: 7,
    title: 'Pagos Pendientes',
    titleMenu: 'Pagos Pendientes',
    icon: <HourglassTopIcon />,
    path: '/Tesorero',
    component: Tesorero,
  },
  {
    id: 8,
    title: 'Solicitudes Pagadas',
    titleMenu: 'Solicitudes Pagadas',
    icon: <PaidIcon />,
    path: '/TesoreroSolicitudes',
    component: TesoreroSolicitudes,
  },
  {
    id: 19,
    title: 'Reporte para Tesorería',
    titleMenu: 'Reporte para Tesorería',
    icon: <RequestPageIcon />,
    path: '/ReporteAutorizadas',
    component: ReporteAutorizadas,
  },

  // ── REPORTES Y AUDITORÍA ─────────────────────────────────────────────────
  {
    id: 18,
    title: 'Seguimiento de Solicitudes',
    titleMenu: 'Seguimiento',
    icon: <PlaylistAddCheckIcon />,
    path: '/SolicitudesAdmin',
    component: SolicitudesAdmin,
  },


  {
    id: 10,
    title: 'Bitácora',
    titleMenu: 'Bitácora',
    icon: <HistoryToggleOffIcon />,
    path: '/Bitacora',
    component: Bitacora,
  },

  // ── CONFIGURACIÓN Y CATÁLOGOS ────────────────────────────────────────────
  {
    id: 25,
    title: 'Carga de Exhibits',
    titleMenu: 'Carga de Exhibits',
    icon: <UploadFileIcon />,
    path: '/ControlExhibits',
    component: ControlExhibits,
  },
  {
    id: 6,
    title: 'Usuarios',
    titleMenu: 'Usuarios',
    icon: <ManageAccountsIcon />,
    path: '/Usuarios',
    component: Usuarios,
  },
  {
    id: 5,
    title: 'Niveles de Autorización',
    titleMenu: 'Niveles de Autorización',
    icon: <RuleIcon />,
    path: '/NivelAut',
    component: NivelAut,
  },
  {
    id: 11,
    title: 'Perfiles',
    titleMenu: 'Perfiles',
    icon: <BadgeIcon />,
    path: '/Perfiles',
    component: Perfiles,
  },
  {
    id: 13,
    title: 'Centros de Costo',
    titleMenu: 'Centros de Costo',
    icon: <AccountBalanceIcon />,
    path: '/CentroCosto',
    component: CentroCosto,
  },
  {
    id: 14,
    title: 'Departamentos',
    titleMenu: 'Departamentos',
    icon: <CorporateFareIcon />,
    path: '/Departamento',
    component: Departamento,
  },
  {
    id: 15,
    title: 'Proveedores',
    titleMenu: 'Proveedores',
    icon: <StoreIcon />,
    path: '/Proveedores',
    component: Proveedores,
  },
  {
    id: 35,
    title: 'Herramientas y Funciones',
    titleMenu: 'Herramientas y Funciones',
    icon: <BuildCircleIcon />,
    path: '/Funciones',
    component: Funciones,
  },
  {
    id: 36,
    title: 'Sincronización de BD',
    titleMenu: 'Sincronización BD',
    icon: <StorageIcon />,
    path: '/ControlBD',
    component: ControlBD,
  },
];
